import hitTemplate from './algolia-custom-hit.js';
//import { infiniteHits } from './algolia-custom-infinite-hits.js';
import { initAlgoliaMobileDrawer } from './algolia-custom-drawer.js';
import { initRefinementListFade } from './algolia-refinement-list-fade.js';
import {
  facetStateSanitizeWidget,
  customerPreferencesWidget,
} from './algolia-my-size.js';
import {
  stripSuggestedRefinementsFromUrl,
  enhanceFacetParams,
  suggestedRefinementWidget,
} from './algolia-suggested-refinement.js';

if (typeof window !== 'undefined') {
  stripSuggestedRefinementsFromUrl();
}

const setSearchInputPlaceholder = () => {
  const searchInput = document.querySelector('#algolia-search-form .aa-Input');
  if (searchInput) {
    searchInput.placeholder = 'Search';
  }
  if (searchInput && !searchInput.classList.contains('blur-init')) {
    searchInput.addEventListener('blur', () => {
      searchInput.classList.add('blur-init');
      searchInput.placeholder = 'Search';
    });
  }
};
window.addEventListener('load', () => {
  setSearchInputPlaceholder();
  const algoliaForm = document.querySelector('#algolia-search-form');
  if (algoliaForm) {
    algoliaForm.addEventListener('change', (e) => {
      setSearchInputPlaceholder();
    });
  }
});
window.addEventListener('resize', () => {
  setSearchInputPlaceholder();
});
function simplifyProductTypeFacetLabels() {
  document.querySelectorAll('.ais-facet-product_type .ais-RefinementList-label')?.forEach(labelEl => {
    if (labelEl?.childNodes) {
      const fullTextNode = Array.from(labelEl.childNodes).find(node => node.nodeType === 3);
      if (fullTextNode) {
        const parts = fullTextNode.textContent.split('>').map(p => p.trim());
        if (parts.length >= 2) {
          fullTextNode.textContent = `${parts[0]} ${parts[parts.length - 1]}`;
        } else {
          fullTextNode.textContent = parts[0];
        }
      }
    }
  });
}

function observeProductTypeChanges() {
  const target = document.querySelector('.ais-facet-product_type');

  if (!target) return;

  const observer = new MutationObserver(() => {
    simplifyProductTypeFacetLabels();
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

function injectLoadingOverlay() {
  if (document.getElementById('algolia-loading-overlay')) return;

  const overlay = document.createElement('div');
  overlay.id = 'algolia-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background: rgba(255, 255, 255, 0.9);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const spinner = document.createElement('div');
  spinner.className = 'spinner';
  spinner.style.cssText = `
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #000;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  `;

  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

  overlay.appendChild(spinner);
  document.head.appendChild(style);
  document.body.appendChild(overlay);
}

function showLoadingOverlay() {
  const overlay = document.getElementById('algolia-loading-overlay');
  if (overlay) overlay.style.display = 'flex';
}

function hideLoadingOverlay() {
  const overlay = document.getElementById('algolia-loading-overlay');
  if (overlay) overlay.style.display = 'none';
}

function enhanceAlgoliaFacetsWithIcons() {
  document.querySelectorAll('.ais-facet-dropdown-wrapper').forEach(wrapper => {
    const isVendor = wrapper.classList.contains('ais-facet-vendor');
    const checkbox = wrapper.querySelector('.ais-dropdown-checkbox');
    const label = wrapper.querySelector('.ais-facet--header');
    const container = wrapper.querySelector('.ais-facet-dropdown-container');

    if (!checkbox || !label || !container) return;

    checkbox.checked = isVendor;

    let icon = label.querySelector('.facet-toggle-icon');
    if (!icon) {
      icon = document.createElement('span');
      icon.className = 'facet-toggle-icon';
      label.appendChild(icon);
    }

    const updateAccordion = () => {
      const isOpen = checkbox.checked;
      icon.textContent = isOpen ? '−' : '+';
      container.style.display = isOpen ? 'block' : 'none';
    };

    updateAccordion();

    checkbox.removeEventListener('change', updateAccordion);
    checkbox.addEventListener('change', updateAccordion);
  });
}

export function initAlgolia(showSpinner = true) {
    const AlgoliaInstantSearchInstance = document.getElementById('algolia-shopify-instantsearch');
    if (!AlgoliaInstantSearchInstance) {
        return;
    }

    if (showSpinner) {
        injectLoadingOverlay();
        showLoadingOverlay();
    }

    algoliaShopify.hooks.registerHook(
        'beforeInstantSearchProductTemplate',
        hitTemplate
    );

    algoliaShopify.hooks.registerHook(
        'beforeInstantSearchStatsTemplate',
        function (defaultTemplate, data, html) {
            return `
            <strong>${algoliaShopify.helpers.formatNumber(data.nbHits)}</strong> result${data.nbHits !== 1 ? 's' : ''} found
            `;
        }
    );

    algoliaShopify.hooks.registerHook('beforeInstantSearchStartAddWidgets', function() {
        // Widget to initialize autocomplete on InstantSearch search input
        const autocompleteWidget = {
            $$type: 'custom.initAutocomplete',
            
            init: function({ instantSearchInstance }) {
                // Store instantSearchInstance for later use
                this.instantSearchInstance = instantSearchInstance;
                
                // Initialize autocomplete on the search input
                const initAutocomplete = () => {
                    const searchInput = document.querySelector('.ais-SearchBox-input');
                    if (!searchInput) {
                        setTimeout(initAutocomplete, 100);
                        return;
                    }
                    
                    // Check if already initialized
                    if (searchInput.hasAttribute('data-autocomplete-initialized')) return;
                    
                    // Wait for Algolia Shopify app to be ready
                    if (typeof window.algoliaShopify === 'undefined' || 
                        !window.algoliaShopify.externals || 
                        !window.algoliaShopify.externals.autocomplete) {
                        setTimeout(initAutocomplete, 100);
                        return;
                    }
                    
                    const { autocomplete, getAlgoliaResults } = window.algoliaShopify.externals;
                    
                    // Get search client and index name from instantSearchInstance
                    const searchClient = instantSearchInstance.client;
                    const indexName = instantSearchInstance.helper.state.index;
                    
                    if (!searchClient || !indexName) {
                        setTimeout(initAutocomplete, 100);
                        return;
                    }
                    
                    try {
                        // Create autocomplete instance
                        const autocompleteInstance = autocomplete({
                            container: searchInput,
                            placeholder: 'Search',
                            openOnFocus: true,
                            getSources({ query }) {
                                if (!query) return [];
                                
                                return [
                                    {
                                        sourceId: 'products',
                                        getItems() {
                                            return getAlgoliaResults({
                                                searchClient,
                                                queries: [
                                                    {
                                                        indexName: indexName,
                                                        query,
                                                    },
                                                ],
                                            }).then(({ results }) => {
                                                return results[0]?.hits || [];
                                            });
                                        },
                                        templates: {
                                            item({ item, components }) {
                                                // Use the same hit template as InstantSearch
                                                return hitTemplate({ item, components });
                                            },
                                        },
                                    },
                                ];
                            },
                            onStateChange({ state }) {
                                // Sync autocomplete query with InstantSearch when user selects an item
                                if (state.isOpen === false && state.query) {
                                    instantSearchInstance.helper.setQuery(state.query).search();
                                }
                            },
                        });
                        
                        // Store autocomplete instance for cleanup if needed
                        searchInput.autocompleteInstance = autocompleteInstance;
                        searchInput.setAttribute('data-autocomplete-initialized', 'true');
                        console.log('Autocomplete initialized on InstantSearch input');
                    } catch (error) {
                        console.error('Error initializing autocomplete:', error);
                    }
                };
                
                // Initialize after a short delay to ensure DOM is ready
                setTimeout(initAutocomplete, 200);
            },
            
            render: function({ results }) {
                // Re-initialize if search input appears later
                const searchInput = document.querySelector('.ais-SearchBox-input');
                if (searchInput && !searchInput.hasAttribute('data-autocomplete-initialized')) {
                    this.init({ instantSearchInstance: this.instantSearchInstance });
                }
            }
        };
        
        const revealWidget = {
            $$type: 'custom.revealOnLoad',
            
            render: function({ results }) {
                if (results && results.nbHits !== undefined) {
                    AlgoliaInstantSearchInstance?.classList.add('algolia-ready');
                    hideLoadingOverlay();
                }
            }
        };

        // Custom infinite scroll widget
        const infiniteScrollWidget = {
            $$type: 'custom.infiniteScroll',
            
            init: function({ helper, instantSearchInstance }) {
                this.helper = helper;
                this.allHits = [];
                this.isLoading = false;
                this.observer = null;
            },
            
            render: function({ results }) {
                if (!results) return;
                
                // Find hits container
                const hitsContainer = document.querySelector('.ais-Hits-list') || 
                                    document.querySelector('[data-widget="hits"]') ||
                                    document.querySelector('.ais-Hits');
                
                if (!hitsContainer) return;
                
                const isLastPage = results.page >= results.nbPages - 1;
                
                // Accumulate hits
                if (results.page === 0) {
                    this.allHits = results.hits;
                } else {
                    // Only add new hits that aren't already in the list
                    const existingIds = new Set(this.allHits.map(h => h.objectID));
                    const newHits = results.hits.filter(h => !existingIds.has(h.objectID));
                    this.allHits = this.allHits.concat(newHits);
                }
                
                // Hide default pagination
                const pagination = document.querySelector('.ais-Pagination');
                if (pagination) {
                    pagination.style.display = 'none';
                }
                
                // Setup intersection observer for infinite scroll
                if (!this.observer && !isLastPage) {
                    let sentinel = document.querySelector('.infinite-scroll-sentinel');
                    
                    if (!sentinel) {
                        sentinel = document.createElement('div');
                        sentinel.className = 'infinite-scroll-sentinel';
                        sentinel.style.height = '1px';
                        sentinel.style.visibility = 'hidden';
                        
                        // Insert after hits container
                        hitsContainer.parentElement.insertBefore(sentinel, hitsContainer.nextSibling);
                    }
                    
                    this.observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting && !this.isLoading && !isLastPage) {
                                this.isLoading = true;
                                this.helper.setPage(results.page + 1).search();
                                setTimeout(() => {
                                    this.isLoading = false;
                                }, 1000);
                            }
                        });
                    }, {
                        rootMargin: '300px'
                    });
                    
                    this.observer.observe(sentinel);
                    this.sentinel = sentinel;
                }
                
                // Remove sentinel on last page
                if (isLastPage && this.sentinel) {
                    if (this.observer) {
                        this.observer.disconnect();
                    }
                    this.sentinel.remove();
                }
            }
        };

        return [
            facetStateSanitizeWidget,
            suggestedRefinementWidget,
            customerPreferencesWidget,
            autocompleteWidget,
            revealWidget,
            //infiniteScrollWidget
        ];
    });

    algoliaShopify.hooks.registerHook(
        'beforeInstantSearchFacetParamsOptions',
        function (params, facet) {
            return enhanceFacetParams(params, facet);
        }
    );

    setTimeout(() => {
        enhanceAlgoliaFacetsWithIcons();
        initAlgoliaMobileDrawer();
        observeProductTypeChanges();
        initRefinementListFade();
    }, 600);
}

initRefinementListFade();

document.addEventListener('algolia.hooks.initialize', initAlgolia);